import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { submitLoad } from "@/lib/offline";
import { CYLINDERS } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Stepper } from "@/components/Stepper";
import { toast } from "sonner";

export default function Load() {
  const navigate = useNavigate();
  const [counts, setCounts] = useState({ DOM_14_2: 0, COM_19: 0, KG_5: 0, FTL_5: 0 });
  const [busy, setBusy] = useState(false);

  const total = Object.values(counts).reduce((a, b) => a + b, 0);

  const save = async () => {
    const items = CYLINDERS.filter((c) => counts[c.code] > 0).map((c) => ({ cylinder_type: c.code, qty: counts[c.code] }));
    if (items.length === 0) { toast.error("Add at least one cylinder"); return; }
    setBusy(true);
    try {
      const res = await submitLoad({ items });
      toast.success(res.queued ? "Saved on phone — will sync when online" : `Loaded ${total} cylinders`);
      navigate("/driver");
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-4 fade-up">
      <h1 className="font-head text-xl font-bold">Load cylinders</h1>
      <div className="space-y-3">
        {CYLINDERS.map((c) => (
          <Card key={c.code} className="p-4 flex items-center justify-between">
            <div className="font-medium">{c.label}</div>
            <Stepper value={counts[c.code]} onChange={(v) => setCounts({ ...counts, [c.code]: v })} testid={`load-stepper-${c.code}`} />
          </Card>
        ))}
      </div>
      <div className="fixed bottom-0 inset-x-0 max-w-md mx-auto p-4 bg-background/95 backdrop-blur border-t">
        <Button className="w-full h-14 text-base" onClick={save} disabled={busy} data-testid="driver-load-confirm-button">Confirm load · {total} cylinders</Button>
      </div>
    </div>
  );
}
